
function updateUrlParameter(key, value) {
  let url = new URL(window.location.href);
  let searchParams = new URLSearchParams(url.search);
  if (searchParams.has(key)) {
    searchParams.set(key, value);
  } else {
    searchParams.append(key, value);
  }
  url.search = searchParams.toString();
  window.history.replaceState({ path: url.href }, '', url.href);
}

const loginTabs = () => {


    const switcherNav = document.querySelector('.woocommerce--logintabs');
    console.log(switcherNav);
    if(switcherNav) {
      const switchInstance = UIkit.switcher(switcherNav);

      UIkit.util.on('#customer_login', 'show', function (e) {
        const index = UIkit.util.index(e.target);
        updateUrlParameter('form',index);
      });


      let urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('form')) {
        setTimeout(() => {

          let id = urlParams.get('form');
          switchInstance.show(id);
          updateUrlParameter('form',id);

        },500)
      }
    }

};

window.addEventListener('DOMContentLoaded', loginTabs);
